import { useState } from "react";
import { Button, Form, Input, Modal, Space, } from 'antd';

import { fetchLogin } from '../../../lib/data';
import { showKeyboard, hideKeyboard } from '../../../lib/keyboard';

export default function LoginModal (props) {
  const { isModalOpen, handleClose, onSuccessLogin } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    values.email = values.email.trim().toLowerCase();
    setIsLoading(true);
    const response = await fetchLogin(values);
    setIsLoading(false);
    hideKeyboard();
    if (!response.success) {
      alert(response.error);
      return;
    }
    onSuccessLogin(response);
  };
  const onClose = () => {
    form.resetFields();
    hideKeyboard();
    handleClose();
  };
  return (
    <Modal
      title="Login"
      open={isModalOpen}
      closable={false}
      footer={null}
      centered>
      <Form
          name="commerce-code-form"
          autoComplete="off"
          layout="vertical"
          form={form}
          disabled={isLoading}
          onFinish={onFinish}>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "El el correo electrónico es requerido!" }]}>
            <Input
              placeholder="Ingrese el correo electrónico"
              onFocus={showKeyboard}
              onBlur={hideKeyboard} />
          </Form.Item>
          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: "La contraseña es requerida!" }]}>
            <Input.Password
              placeholder="Ingresa la contraseña"
              onFocus={showKeyboard}
              onBlur={hideKeyboard} />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="default" htmlType="button" onClick={onClose}>
                Cerrar
              </Button>
              <Button type="primary" htmlType="submit">
                Enviar
              </Button>
            </Space>
          </Form.Item>
        </Form>
    </Modal>
  );
}